module.exports = __webpack_public_path__ + "cb5a2b9c32ed905c403be62f4e87eb8e.MP3";